exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.con-vs-popup[data-v-b804740c] .vs-popup {\n  width: 1000px !important;\n  height: auto !important;\n}\n.vx-row[data-v-b804740c] {\n  -webkit-transition: all 1s;\n  transition: all 1s;\n}\n.field-type-select[data-v-b804740c] .vs__dropdown-menu {\n  height: 168px !important;\n}\n.vs-con-table[data-v-b804740c] .vs-con-tbody {\n  background: #ffffff !important;\n}\n.vs-slider--circles.isEndValue[data-v-b804740c] {\n  border-radius: 50% !important;\n}\n\n/* div.con-vs-chip {\r\n  min-height: 20px!important;\r\n  min-width: 0px!important;\r\n  font-size: .6rem;\r\n} */\r\n", ""]);

// exports
